import React, { useEffect, useRef, useState } from 'react';
import { makeStyles, Tooltip, Typography } from '@material-ui/core';
import clsx from 'clsx';
import SvgCircle from './svgCircle';
// import SrIconButton from 'core/srIconButton/srIconButton';
// import { AccountBoxOutlined } from '@material-ui/icons';

const useStyles = makeStyles(() => ({
  row: {
    display: 'flex',
    height: 58,
    alignItems: 'center',
    justifyContent: 'space-around',
    background: '#fff',
    borderBottom: 'solid 1px rgba(0, 0, 0, 0.12)',
  },
  listHeaderText: {
    fontSize: '14px',
    fontWeight: 'normal',
    color: '#60676f',
    display: 'flex',
    flex: '0 0 20%',
    justifyContent: 'center',

    '& b': {
      fontWeight: 500,
      color: '#49515a',
    },
  },
  fileNameText: {
    flex: '0 0 40%',
    justifyContent: 'flex-start',
    WebkitLineClamp: '2',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    maxHeight: '40px',
    minHeight: '20px',
  },
  hiddenIcon: {
    opacity: 0,
    cursor: 'default',
  },
  resumeIcon: {
    transition: 'all 0.2s linear',
  },
}));

const TalentListRow = ({ profileName, score, docId, rank, onClickResume }) => {
  const classes = useStyles();
  const nameRef = useRef(null);
  const [nameHeight, setNameHeight] = useState(20);
  // const [showResume, setShowResume] = useState(false);

  useEffect(() => {
    if (nameRef.current && nameRef.current.clientHeight) {
      setTimeout(() => {
        if (nameRef.current) {
          setNameHeight(nameRef.current.clientHeight);
        }
      }, 1000);
    }
  });

  const WrapInTooltip = ({ children }) => {
    if (nameHeight >= 40) {
      return <Tooltip title={profileName}>{children}</Tooltip>;
    }

    return children;
  };

  // const toggleShowResume = () => {
  //   setShowResume(prevState => !prevState);
  // }

  return (
    <div
      className={classes.row}
      key={docId}
      // onMouseEnter={toggleShowResume} onMouseLeave={toggleShowResume}
    >
      <Typography classes={{ root: classes.listHeaderText }}>
        <b>{rank}</b>
      </Typography>
      <WrapInTooltip>
        <Typography
          ref={nameRef}
          classes={{
            root: clsx(classes.listHeaderText, classes.fileNameText),
          }}
        >
          {profileName}
        </Typography>
      </WrapInTooltip>

      <Typography classes={{ root: classes.listHeaderText }}>
        <SvgCircle match={score} />
      </Typography>
      {/* <SrIconButton Icon={AccountBoxOutlined} className={clsx({ [classes.hiddenIcon]: !showResume }, classes.resumeIcon)} onClick={onClickResume} /> */}
    </div>
  );
};

export default TalentListRow;
